import requests from "@/common/fetch";
import { toCamelCase } from "@/common/util/transform";
import { Result } from "../common";
import * as I from "./interface";

/** 查询签署状态 */
export const queryAgreement = (): Result<I.QueryAgreementResult> => {
  return toCamelCase(requests.post("/mmsapi/brandbank/sign_agreement/query"));
};

/** 签署线上协议 */
export const signAgreement = (): Result<I.SignAgreementResult> => {
  return toCamelCase(requests.post("/mmsapi/brandbank/sign_agreement/sign"));
};
